package org.hs_soft.runmynesto.pages.components.checkout.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.getGeneralItemRatio
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.checkout.getArrowImg
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun DeviceLocation(
    checkedValue: Boolean,
    title: String,
    isExpandedAll:Boolean,
    ratioChecked: String,
    showCheckBox: Boolean,
    unCheckItem: () -> Unit,
    checkItem: () -> Unit,
    content: @Composable () -> Unit,
)
{
    val isExpanded= remember{ mutableStateOf(isExpandedAll) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .cursor(Cursor.Pointer)
            .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                isExpanded.value=!isExpanded.value
            },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = Dimen.normalPadding)
                .height(Dimen.checkOutItemHeight),
            verticalAlignment = Alignment.CenterVertically
        )
        {
            if (showCheckBox){
                CheckboxComponent(
                    modifier = Modifier,
                    checkStatus = checkedValue,
                    title = "",
                    onChecked = {checkItem()},
                    onUnChecked = {unCheckItem()},
                )
            }


            VectorIcon(
                modifier = Modifier,
                pathData = Res.PathIcon.location,
                width = Dimen.normalIconSize,
                height = Dimen.normalIconSize,
                color = Theme.TextDisabled.hex
            )

            SpanText(
                text = title,
                modifier = Modifier
                    .margin(left = Dimen.semiNormalPadding)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.mediumFontSize,)
                    .color(Theme.TextPrimary.rgb),
            )

            Spacer()

            SpanText(
                text = ratioChecked,
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .margin(leftRight = Dimen.smallPadding)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize( FontSizes.normalFontSize)
                    .color(Theme.TextPrimary.rgb),
            )


            VectorIcon(
                pathData = getArrowImg(expanded = isExpanded.value),
                width = Dimen.mediumIconSize,
                height = Dimen.mediumIconSize,
                color = Theme.ActionActive.hex,
            )



        }


        if (isExpanded.value){
            Column(
                modifier = Modifier
                    .backgroundColor(Theme.White.rgb)
                    .borderRadius(Dimen.semiLargeRadius)
                    .border(
                        color = Theme.Divider.rgb,
                        style = LineStyle.Solid,
                        width = Dimen.smallThickness
                    )
                    .width(Dimen.storeItemWidth)
                    .margin(topBottom = Dimen.normalPadding)
                ,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                content()
            }
        }


        Separator()


    }


}